<template>
  <mdb-row>
    <mdb-col offsetMd="3" md="6">
      <mdb-card>
        <mdb-card-body>
          <mdb-card-title class="indigo-text"><mdb-icon icon="lock"/> 비밀번호 변경</mdb-card-title>
          <mdb-card-text>
            <form>
              <mdb-input type="password" label="이전 비밀번호" v-model="oldPassword"/>
              <mdb-input type="password" label="새 비밀번호" v-model="newPassword"/>
              <mdb-input type="password" label="새 비밀번호 확인" v-model="newPassword2"/>
              <mdb-alert color="danger" v-if="error">{{error}}</mdb-alert>
              <div class="text-center">
                <mdb-btn icon="check" @click="onSubmit()" :disabled="!isValid">수정</mdb-btn>
                <mdb-btn icon="undo" @click="$router.push({name:'Profile'})">돌아가기</mdb-btn>
              </div>
            </form>
          </mdb-card-text>
        </mdb-card-body>
      </mdb-card>
    </mdb-col>
  </mdb-row>
</template>
<script>
import { mdbIcon, mdbBtn, mdbInput, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbCardTitle, mdbCardText, mdbAlert } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import authService from '@/service/auth'
export default {
  name: 'PasswordChangePage',
  components: { mdbIcon, mdbInput, mdbBtn, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbCardTitle, mdbCardText, mdbAlert },
  data: () => ({
    error: '',
    oldPassword: '',
    newPassword: '',
    newPassword2: ''
  }),
  computed: {
    ...mapState('auth', ['profile']),
    isValid () {
      const { oldPassword, newPassword, newPassword2 } = this;
      return oldPassword.length && newPassword.length && newPassword2.length;
    }
  },
  methods: {
    async onSubmit () {
      const { oldPassword, newPassword, newPassword2 } = this;
      if (newPassword !== newPassword2) {
        return alert('비밀번호 확인이 일치하지 않습니다.');
      }
      const data = {
        userId: this.profile.userId,
        oldPassword,
        newPassword
      }
      const res = await authService.changePassword(data);
      if (res.result === 'ok') {
        this.$router.push({ name: 'Profile' });
      } else {
        this.error = res.reason;
      }
    }
  }
}
</script>
